import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseWalletManage() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      cost1: isEmpty(state.cost1),
      file: isEmpty(imgState.url),
    };

    setter(errorState);

    if (errorState.title || errorState.cost1) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (errorState.file) {
      enqueueSnackbar("لطفا تصویر را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getRequestWalletList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ManageWallets/RequestWallet?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const geRequestById = (id, callback) => {
    MyAxios.get(`Admin_ManageWallets/RequestWallet/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const ConfirmWallet = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ManageWallets/ConfirmWallet`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const getOffersList = (callback) => {
    MyAxios.get(`Admin_ManageWallets/WalletOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const geOfferById = (id, callback) => {
    MyAxios.get(`Admin_ManageWallets/WalletOffers/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddOffer = (state, Image, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    MyAxios.post(`Admin_ManageWallets/WalletOffers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  const EditOffer = (state, Image, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    MyAxios.put(`Admin_ManageWallets/WalletOffers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteOffer = (WalletOfferID, callback) => {
    const data = new FormData();
    data.append("WalletOfferID", WalletOfferID);
    MyAxios.delete(`Admin_ManageWallets/WalletOffers`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("آفر با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getRequestWalletList,
    geRequestById,
    ConfirmWallet,
    getOffersList,
    geOfferById,
    AddOffer,
    EditOffer,
    deleteOffer,
    validate,
  };
}
